<div class="tf-multi-select-container">
  <div class="tf-multi-select-dropdown" [ngStyle]="{'border-bottom': overlayVisible ? 'none':''}" (click)="onMouseClick($event)"
       [ngClass]="disable ? 'tf-disable-drop-down' : ''">
    <span *ngIf="isItemSelected || !externalLabel" class="tf-multi-select-placeholder"
          [ngClass]="{'tf-multi-select-small-padding': size == 'small',
                      'tf-multi-select-medium-padding': size == 'medium' && ((isItemSelected && externalLabel) || !isItemSelected),
                      'tf-multi-select-large-padding': size == 'large' && ((isItemSelected && externalLabel) || !isItemSelected) ,
                      'tf-multi-select-medium-padding-with-floating-label': size == 'medium' && isItemSelected && !externalLabel,
                      'tf-multi-select-large-padding-with-floating-label': size == 'large' && isItemSelected && !externalLabel}"
          [ngStyle]="{'border-left': isItemSelected ? '4px solid #0f88ea':'4px solid transparent'}">
      <p [ngStyle]="{'top': size == 'large' ? '7px':'2px'}" *ngIf="isItemSelected && !externalLabel && size != 'small'">{{inlineLabel}}</p>
      {{valueAsString}}
    </span>
    <span *ngIf="!isItemSelected && externalLabel" class="tf-placeholder-external tf-multi-select-placeholder"
          [ngClass]="{'tf-multi-select-small-padding': size == 'small',
                      'tf-multi-select-medium-padding': size == 'medium',
                      'tf-multi-select-large-padding': size == 'large'}">Select</span>
    <i class="tf-arrow"
       [ngStyle]="{'border-bottom': overlayVisible ? '5px solid #222':'', 'border-top': overlayVisible ? '0px': '', 'top': size == 'large' ? '23px': size == 'small' ? '13px' : '18px'}"></i>
    </div>
  <ul *ngIf="overlayVisible" class="tf-multi-select-options" [style.max-height]="scrollHeight + 'px'||'auto'" [style.width]="overlayWidth">
    <div *ngIf="search" class="tf-dropdown-search-box" (click)="filterOptions()">
      <input #searchInput tfFormInput [placeholder]="searchPlaceHolder" (change)="filterOptions()"
             [name]="searchPlaceHolder"
             [(ngModel)]="searchInputValue" (blur)="onSearchInputBlur()"/>
      <span class="tf-icon-search tf-dropdown-search-icon" (click)="filterOptions()"></span>
    </div>
    <div #optionsBlock
         [ngStyle]="{'max-height':scrollHeight?(search?scrollHeight-72+'px':scrollHeight+'px'):(search? '203px': '285px'),'overflow':'auto'}">
      <div *ngIf="!virtualScroll">
        <div *ngFor="let option of visibleOptions">
          <li [attr.title]="getLabel(option)" (click)="onOptionWrapperClick($event, option)">
            <tf-checkbox [id]="getLabel(option)" [label]="getLabel(option)" [name]="getLabel(option)"
                          [(ngModel)]="option['isChecked']" (onClick)="onOptionClick($event,option)"
                          [disabled]=" option.disabled ? true : false" class="dropdown-checkbox" width="100%"></tf-checkbox>
          </li>
        </div>
      </div>
      <virtual-scroller *ngIf="virtualScroll" #scroll class="virtual-scroller" [items]="visibleOptions"
                        [childHeight]="13" [parentScroll]="optionsBlock">
        <div *ngFor="let option of scroll.viewPortItems">
          <li [attr.title]="getLabel(option)" (click)="onOptionWrapperClick($event, option)">
            <tf-checkbox [id]="getLabel(option)"[label]="getLabel(option)" [name]="getLabel(option)"
                          [(ngModel)]="option['isChecked']" (onClick)="onOptionClick($event,option)"
                          [disabled]=" option.disabled ? true : false" width="100%"></tf-checkbox>
          </li>
        </div>
      </virtual-scroller>
    </div>
  </ul>
</div>
